import React from 'react';
import { Button, Fab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactSVG } from 'react-svg';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import { getSpaceHost } from '../../Utils/routes';
import CustomIcon from '../DesignSystem/CustomIcon';
import { Icons } from '../../Themes';

const StyledFab = styled(Fab)(({ theme }: any) => ({
  fontSize: 29,
  width: 45,
  height: 45,
  backgroundColor: theme.palette.background.paper,
}));

const StyledReactSVG = styled(ReactSVG)({
  width: 22,
  paddingTop: 2,
});

function CsamButton({ disabled, space, fullText, text = 'CSAM', onClick, redirectTo }: any) {
  const intl = useIntl();
  const { search } = useLocation();
  const params = qs.parse(search?.slice(1));
  const redirectUrl = redirectTo || params.redirect_to || window.location.pathname;

  const handleClick = () => {
    // when the user already has a login id, we don't really want to trigger the login process
    // we just fake it, and move on
    if (onClick && typeof onClick === 'function') {
      onClick();
    } else {
      window.location.href = `${window.runtimeEnv?.REACT_CSAM_API_BASE_URL}/authorize?client_id=${
        space.csam_client_id
      }&nonce=1244542&response_type=code&scope=openid%20profile%20egovnrn&acr_values=urn:be:fedict:iam:fas:Level200&state=${encodeURIComponent(
        redirectUrl,
      )}&redirect_uri=https://${getSpaceHost(space.custom_domain)}/oauthFAS/auth`;
    }
  };

  if (fullText) {
    return (
      <Button
        startIcon={<CustomIcon src={Icons.misc.csamLoginIcon} size={22} color="x" />}
        disabled={disabled}
        onClick={handleClick}
        aria-label={intl.formatMessage({ id: 'AUTH.ARIA_AUTHENTICATE_WITH' }, { provider: 'CSAM' })}
        size="large"
        variant="outlined"
        color="primary"
      >
        {text}
      </Button>
    );
  }

  return (
    <StyledFab disabled={disabled} aria-label="SignUp with Csam" onClick={handleClick}>
      <StyledReactSVG src={Icons.misc.csamLoginIcon} />
    </StyledFab>
  );
}

export default CsamButton;
